import { StyledEmptyBasketWrapper } from '@/components/modules/basket-page/styled';
import { useAppSelector } from '@/store/hooks';

import { useTranslate } from '@/shared/hooks/use-translate';
import { MenuBookIcon, BasketIcon2 } from '@/shared/ui/icons';
import { LinkButton } from '@/shared/ui/link-button';

export const BasketBlockEmpty = (): JSX.Element => {
    const { t } = useTranslate();
    const cityUser = useAppSelector((state) => state.user.cityUser);
    return (
        <StyledEmptyBasketWrapper>
            <div className="content">
                <div className="ico">
                    <BasketIcon2 />
                </div>
                <div className="title1">{t('В корзине еще ничего нет')}</div>
                <div className="title2">{t('Сложите в корзину то, что хотите арендовать 🥰')}</div>
                <div className="button">
                    <LinkButton slug={`/${cityUser?.slug}`} variant="dark">
                        <MenuBookIcon /> {t('К каталогу')}
                    </LinkButton>
                </div>
            </div>
        </StyledEmptyBasketWrapper>
    );
};
